import { useQuery } from '@apollo/client/react';
import { useCallback } from 'react';

import { getMemberId } from '@trello/authentication';

import { TrelloMemberPlannerAccountStatusDocument } from './TrelloMemberPlannerAccountStatusQuery.generated';

interface MemberHasValidPlannerAccount {
  hasValidAccount: boolean;
  refetchAccountStatus: () => void;
}

/**
 * Whether the member has a Planner calendar account Smart Schedule can schedule
 * into — required scopes present and not expired.
 */
export const useMemberHasValidPlannerAccount =
  (): MemberHasValidPlannerAccount => {
    const memberAri = getMemberId({ returnAri: true });

    // oxlint-disable-next-line @trello/no-apollo-refetch -- OAuth connect has no mutation result to write, so status is re-read after auth
    const { data, refetch } = useQuery(
      TrelloMemberPlannerAccountStatusDocument,
      {
        variables: { memberId: memberAri },
        skip: !memberAri,
      },
    );

    const hasValidAccount =
      data?.trello.member?.planner?.accounts?.edges?.some(
        (edge) => edge?.node?.hasRequiredScopes && !edge?.node?.isExpired,
      ) ?? false;

    const refetchAccountStatus = useCallback(() => {
      void refetch();
    }, [refetch]);

    return { hasValidAccount, refetchAccountStatus };
  };
